import { useQuery } from '@tanstack/react-query';

import { getDataLakeMetadata } from './request';

export const GET_DATA_LAKE_METADATA = 'data-lake-metadata';

export function useGetDataLakeMetadata() {
  return useQuery({
    queryKey: [GET_DATA_LAKE_METADATA],
    queryFn: getDataLakeMetadata,
  });
}
